import * as yup from "yup";
import { VALIDATION_REGEX } from "utils/constants";
import i18next from "config/i18next";
import "pages/detailPicker/accountData/i18n";

const requiredMessage = i18next.t("validations:required");

const requiredString = yup.string().required(requiredMessage);

export const personalData = (
  approve?: boolean,
  hasComeFromCode?: boolean,
  duplicatedEmailOrUsername?: boolean
) =>
  yup.object({
    name: yup
      .string()
      .concat(requiredString)
      .matches(
        VALIDATION_REGEX.expName,
        i18next.t("validations:numbersOrSpecialCharacters")
      ),
    surname: yup
      .string()
      .concat(requiredString)
      .matches(
        VALIDATION_REGEX.expName,
        i18next.t("validations:numbersOrSpecialCharacters")
      ),
    email: yup
      .string()
      .trim()
      .concat(requiredString)
      .matches(
        VALIDATION_REGEX.regEmail,
        i18next.t("validations:invalidEmailFormat")
      )
      .test(
        "duplicatedEmailOrUsername",
        i18next.t("account:fiscalNumberDuplicated"),
        () => !duplicatedEmailOrUsername
      ),
    phone: yup.object({
      areaNumber: yup
        .string()
        .concat(requiredString)
        .matches(
          VALIDATION_REGEX.regArea,
          i18next.t("validations:enterValidFormat")
        ),
      number: yup
        .string()
        .concat(requiredString)
        .matches(
          VALIDATION_REGEX.regTelefono,
          i18next.t("validations:enterValidFormat")
        ),
    }),
    comeFromCode:
      hasComeFromCode && approve
        ? yup.string().concat(requiredString)
        : yup.string(),
  });
